/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import clsx from 'clsx';
import React, { createRef, useMemo } from 'react';
import { Chip, ChipProps } from '../Chip';
import { ChipListProps } from './ChipList.props';

/**
 * SDS ChipList component.
 */
export const ChipList = (props: ChipListProps): JSX.Element => {
  const { chips, classes, theme, type, ...rest } = props;
  const listClass = clsx(`sds-chip-list`, classes);

  // Create refs
  const chipRefs = useMemo<Array<React.RefObject<HTMLDivElement>>>(
    () =>
      Array.from(
        {
          length: chips.length,
        },
        () => createRef<HTMLDivElement>(),
      ),
    [chips],
  );

  const getChips = (): Array<JSX.Element> => {
    return chips.map((chip, index): JSX.Element => {
      const chipProps: ChipProps = {
        customClick: chip.customClick,
        icon: chip.icon,
        iconColour: chip.iconColour,
        iconPosition: chip.iconPosition,
        text: chip.text,
        theme: theme || chip.theme,
        type: chip.type,
      } as ChipProps;

      if (type) {
        chipProps.type = type;
      }

      return <Chip {...chipProps} key={chip.key} ref={chipRefs[index]} />;
    });
  };

  if (chips.length > 0) {
    return (
      <ul className={listClass} {...rest}>
        {getChips()}
      </ul>
    );
  }

  return <></>;
};
